import { useEffect, useState } from "react";
import PageShell from "../components/common/PageShell";
import { getProfileApi } from "../api/userApi";
import { inr, errMsg } from "../utils/format";

export default function Profile() {
  const [user, setUser] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    let alive = true;
    getProfileApi()
      .then((res) => {
        const d = res.data?.data || {};
        if (!alive) return;
        setUser(d.user || null);
        setWallet(d.wallet || null);
      })
      .catch((e) => alive && setErr(errMsg(e)));
    return () => {
      alive = false;
    };
  }, []);

  const walletItems = wallet
    ? [
        ["Deposit balance", wallet.depositBalance, true],
        ["Winning balance", wallet.winningBalance, true],
        ["Bonus", wallet.bonusBalance],
        ["Cashback", wallet.cashbackBalance],
        ["Referral earning", wallet.referralEarning],
        ["Locked", wallet.lockedBalance],
      ]
    : [];

  return (
    <PageShell title="My Profile">
      {err && <p className="pg-lose">{err}</p>}
      {!user && !err && <p className="pg-empty">Loading profile...</p>}

      {user && (
        <>
          <section className="pg-card pg-hero">
            <div className="pg-avatar">
              {(user.username || "P")[0].toUpperCase()}
            </div>
            <div>
              <h2>{user.username}</h2>
              <span className="pg-muted">{user.userId}</span>
              {wallet?.vipLevel && (
                <div>
                  <span className="pg-vip">{wallet.vipLevel}</span>
                </div>
              )}
            </div>
          </section>

          {wallet && (
            <section className="pg-card">
              <h2>Wallet</h2>
              <div className="pg-wallet">
                {walletItems.map(([k, v, hi]) => (
                  <div className="pg-stat" key={k}>
                    <span className="pg-muted">{k}</span>
                    <b className={hi ? "pg-win" : ""}>{inr(v)}</b>
                  </div>
                ))}
              </div>
            </section>
          )}

          <section className="pg-card">
            <h2>Account details</h2>
            <div className="pg-row">
              <span>Mobile</span>
              <b>{user.mobile}</b>
            </div>
            <div className="pg-row">
              <span>Referral code</span>
              <b>{user.referralCode}</b>
            </div>
            <div className="pg-row">
              <span>Status</span>
              <b className="pg-win">{user.status}</b>
            </div>
            <div className="pg-row">
              <span>Joined</span>
              <b>{new Date(user.createdAt).toLocaleDateString("en-IN")}</b>
            </div>
          </section>
        </>
      )}
    </PageShell>
  );
}
